import React, { useState, useEffect } from "react";
import axios from "../../../../Axiosinstance";
import TablePagination from "@mui/material/TablePagination"; // Import TablePagination component
import {
  TableBody,
  TableCell,
  Pagination,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Collapse,
  IconButton,
  CircularProgress,
  Box,
  Alert,
  Snackbar,
  Tooltip,
  DialogContentText,
  Grid,
  TextField,
  Select,
  MenuItem,
  Link,
} from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Download as DownloadIcon } from "@mui/icons-material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  PauseCircleOutline,
} from "@mui/icons-material";
import { Table, Button, Modal, Form } from "react-bootstrap";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DiscountIcon from "@mui/icons-material/Discount";
import SendIcon from "@mui/icons-material/Send"; // Import the SendIcon
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import calibriFontBold from "../../../../fonts/CalibriBold.ttf";
import calibriFont from "../../../../fonts/calibri.ttf";
import fontkit from "@pdf-lib/fontkit";
import Invoice_company from "../../../DOC/WSQ-Invoice-Company.pdf";
import { ToastContainer } from "react-toastify";
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from "../../../../common";





const StudentDetailsTable = ({ students, onActionComplete }) => {
  const Name = localStorage.getItem("name");
  const [showWithoutDiscountModal, setShowWithoutDiscountModal] =
    useState(false);
  const [showWithDiscountModal, setShowWithDiscountModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [discountAmount, setDiscountAmount] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    emailId: [],
    contactNumber: [],
    nric: "",
    dob: "",
    ic: "",
    registration_Form: "",
    supporting_Documents: "",
  });

  const handleAction = async (studentId, action, discount = 0) => {
    setIsProcessing(true);
    const url = `/wsq/approves`;

    const data = {
      studentId,
      discountAmount: discount,
      approve: Name,
      status: action,
    };

    try {
      const response = await axios.put(url, null, { params: data });
      if (response.status === 200) {
        alert(`Student ${action}d successfully!`);
        onActionComplete();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      alert("An error occurred while processing your request.");
    } finally {
      setIsProcessing(false); // Set loading state to false after API call
    }
  };

  const handleApproveWithoutDiscountClick = (student) => {
    setSelectedStudent(student);
    setShowWithoutDiscountModal(true);
  };

  const handleApproveWithDiscountClick = (student) => {
    setSelectedStudent(student);
    setShowWithDiscountModal(true);
    setDiscountAmount("");
  };

  const handleEditClick = (student) => {
    setSelectedStudent(student);
    setFormData({
      name: student.name,
      emailId: student.emailId,
      contactNumber: student.contactNumber,
      nric: student.nric,
      dob: student.dob,
      ic: student.ic || "", // Load existing file URL or empty string
      registration_Form: student.registration_Form || "", // Load existing file URL or empty string
      supporting_Documents: student.supporting_Documents || "", // Load existing file URL or empty string
    });
    setShowEditModal(true);
  };

  const handleFormChange = (e, index = null, fieldType = null) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      if (fieldType === "email") {
        const updatedEmails = [...prevData.emailId];
        if (index !== null) {
          updatedEmails[index] = value;
        }
        return { ...prevData, emailId: updatedEmails };
      }

      if (fieldType === "contactNumber") {
        const updatedContactNumbers = [...prevData.contactNumber];
        if (index !== null) {
          updatedContactNumbers[index] = value;
        }
        return { ...prevData, contactNumber: updatedContactNumbers };
      }

      return { ...prevData, [name]: value };
    });
  };

  const handleFileUpload = async (e, fieldName) => {
    try {
      const file = e.target.files[0];

      if (!file) return; // Exit if no file is selected

      const formDataUpload = new FormData(); // FormData for uploading the file
      formDataUpload.append("file", file);
      formDataUpload.append("upload_preset", CLOUDINARY_UPLOAD_PRESET); // Cloudinary upload preset

      const response = await fetch(baseURL, {
        method: "POST",
        body: formDataUpload,
      });

      const data = await response.json();

      if (data.secure_url) {
        const uploadedFileUrl = data.secure_url;

        // Update formData state with the uploaded file URL
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: uploadedFileUrl, // Update the specific field with the file URL
        }));
      }
    } catch (err) {
      console.error("File upload error:", err);
    }
  };


  const handleAddEmail = () => {
    setFormData((prevState) => ({
      ...prevState,
      emailId: [...prevState.emailId, ""], // Add an empty string for a new email input
    }));
  };

  const handleRemoveEmail = (index) => {
    setFormData((prevState) => {
      const updatedEmails = [...prevState.emailId];
      updatedEmails.splice(index, 1); // Remove the selected email
      return { ...prevState, emailId: updatedEmails };
    });
  };

  const handleAddContactNumber = () => {
    setFormData((prevState) => ({
      ...prevState,
      contactNumber: [...prevState.contactNumber, ""], // Add an empty string for a new contact number input
    }));
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate); // Convert ISO string to Date object
    const year = date.getFullYear(); // Get full year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad to 2 digits
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad to 2 digits
    return `${year}-${month}-${day}`; // Return in YYYY-MM-DD format
  };

  const handleRemoveContactNumber = (index) => {
    setFormData((prevState) => {
      const updatedNumbers = [...prevState.contactNumber];
      updatedNumbers.splice(index, 1); // Remove the selected contact number
      return { ...prevState, contactNumber: updatedNumbers };
    });
  };
  // Handle form submission
  const handleFormSubmit = async () => {
    if (!selectedStudent) {
      alert("No student selected!");
      return;
    }

    const studentId = selectedStudent.id; // Retrieve the student ID from the selectedStudent state
    try {
      // Perform PUT request to update student details
      const response = await axios.put(
        `wsq/${studentId}/selfStudent`,
        formData
      );

      if (response.status === 200) {
        console.log("Student details updated successfully:", response.data);
        alert("Student details updated successfully!");
        onActionComplete(); // Call the callback to refresh data
      } else {
        console.error("Failed to update student details");
        alert("Failed to update student details. Please try again.");
      }
    } catch (error) {
      console.error("Error updating student details:", error);
      alert("An error occurred while updating student details.");
    }

    // Close modal after submitting
    handleCloseModals();
  };

  const handleCloseModals = () => {
    setShowWithoutDiscountModal(false);
    setShowWithDiscountModal(false);
    setShowEditModal(false);
    setSelectedStudent(null);
    setDiscountAmount("");
  };


  const handleConfirmApproveWithoutDiscount = () => {
    if (selectedStudent) {
      handleAction(selectedStudent.id, "approve");
      handleCloseModals();
    }
  };

  const handleConfirmApproveWithDiscount = () => {
    if (selectedStudent) {
      handleAction(selectedStudent.id, "approve", parseFloat(discountAmount));
      handleCloseModals();
    }
  };


  return (
    <>
      <Table size="sm" striped bordered hover>
        <thead>
          <tr>
            <th>Student ID</th>
            <th>Name</th>
            <th>Status</th>
            <th>Email</th>
            <th>ContactNumber</th>
            <th>NRIC</th>
            <th>Date of Birth</th>
            <th>Documents</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.length > 0 ? (
            students.map((student) => (
              <tr key={student.id}>
                <td>{student.id}</td>
                <td>{student.name}</td>
                <td>{student.status}</td>
                <td>
                  {student.emailId.map((email, index) => (
                    <div key={index}>{email}</div>
                  ))}
                </td>
                <td>
                  {student.contactNumber.map((number, index) => (
                    <div key={index}>{number}</div>
                  ))}
                </td>
                <td>{student.nric}</td>
                <td>{new Date(student.dob).toLocaleDateString("en-GB")}</td>
                <td>
                  <>
                    <Link
                      href={student.registration_Form}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InsertDriveFileIcon
                        color="primary"
                        titleAccess="Registration Form"
                      />
                    </Link>
                    <Link
                      href={student.ic}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InsertDriveFileIcon color="secondary" titleAccess="IC" />
                    </Link>
                    <Link
                      href={student.supporting_Documents}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InsertDriveFileIcon
                        color="action"
                        titleAccess="Supporting Documents"
                      />
                    </Link>
                  </>
                </td>
                <td>
                  {student.status === "new" ? (
                    <>
                      {/* <IconButton
                        color="primary"
                        onClick={() => handleApproveWithDiscountClick(student)}
                        disabled={isProcessing} // Disable button if action is being processed
                      >
                        <DiscountIcon titleAccess="Approve with Discount" />
                      </IconButton> */}
                      <IconButton
                        color="success"
                        onClick={() =>
                          handleApproveWithoutDiscountClick(student)
                        }
                        disabled={isProcessing} // Disable button if action is being processed
                      >
                        <CheckCircleIcon titleAccess="Approve without Discount" />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleAction(student.id, "reject")}
                        disabled={isProcessing} // Disable button if action is being processed
                      >
                        <CancelIcon titleAccess="Reject" />
                      </IconButton>
                      <IconButton
                        color="warning"
                        onClick={() => handleAction(student.id, "hold")}
                        disabled={isProcessing} // Disable button if action is being processed
                      >
                        <PauseCircleOutline titleAccess="Hold" />
                      </IconButton>
                    </>
                  ) : null}
                  {/* Always show the Edit button */}
                  <IconButton
                    color="primary"
                    onClick={() => handleEditClick(student)}
                    disabled={isProcessing}
                  >
                    <EditIcon titleAccess="Edit" />
                  </IconButton>
                  <span>{student.status}</span>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Modal for Approve without Discount */}
      <Modal show={showWithoutDiscountModal} onHide={handleCloseModals}>
        <Modal.Header closeButton>
          <Modal.Title>Approve Student </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to approve {selectedStudent?.name}?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmApproveWithoutDiscount}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Approve with Discount */}
      <Modal show={showWithDiscountModal} onHide={handleCloseModals}>
        <Modal.Header closeButton>
          <Modal.Title>Approve Student With Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Enter the discount amount for {selectedStudent?.name}:</p>
          <Form.Group>
            <Form.Label>Discount Amount</Form.Label>
            <Form.Control
              type="text"
              value={discountAmount}
              onChange={(e) => setDiscountAmount(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmApproveWithDiscount}
            disabled={!discountAmount || isNaN(parseFloat(discountAmount))}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={handleCloseModals} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Student Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Name Input */}
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFormChange}
                placeholder="Enter full name"
              />
            </Form.Group>

            {/* Email Inputs */}
            <Form.Label>Email</Form.Label>
            {formData.emailId.map((emailId, index) => (
              <Form.Group controlId={`formEmail-${index}`} key={index} className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  value={emailId}
                  onChange={(e) => handleFormChange(e, index, "email")}
                  placeholder="Enter email"
                />
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleRemoveEmail(index)}
                  className="mt-2"
                >
                  Remove
                </Button>
              </Form.Group>
            ))}
            <Button variant="success" onClick={handleAddEmail} className="mt-2">
              Add Email
            </Button>
            <br></br>
            {/* Contact Number Inputs */}
            <Form.Label  >Contact Number</Form.Label>
            {formData.contactNumber.map((number, index) => (
              <Form.Group controlId={`formContactNumber-${index}`} key={index} className="mb-3">
                <Form.Control
                  type="text"
                  name="contactNumber"
                  value={number}
                  onChange={(e) => handleFormChange(e, index, "contactNumber")}
                  placeholder="Enter contact number"
                />
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleRemoveContactNumber(index)}
                  className="mt-2"
                >
                  Remove
                </Button>
              </Form.Group>
            ))}
            <Button variant="success" onClick={handleAddContactNumber} className="mt-2">
              Add Contact
            </Button>

            {/* NRIC Input */}
            <Form.Group controlId="formNRIC" className="mt-3">
              <Form.Label>NRIC</Form.Label>
              <Form.Control
                type="text"
                name="nric"
                value={formData.nric}
                onChange={handleFormChange}
                placeholder="Enter NRIC"
              />
            </Form.Group>

            {/* Date of Birth Input */}
            <Form.Group controlId="formDOB" className="mt-3">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={formatDate(formData.dob)}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formIC" className="mt-3">
  <Form.Label>IC</Form.Label>
  <Form.Control
    type="file"
    name="ic"
    onChange={(e) => handleFileUpload(e, "ic")}
  />
  {formData.ic && (
    <a href={formData.ic} target="_blank" rel="noopener noreferrer">
      {formData.ic.split('/').pop() || "View IC"}
    </a>
  )}
</Form.Group>

{/* Registration Form File Upload */}
<Form.Group controlId="formRegistrationForm" className="mt-3">
  <Form.Label>Registration Form</Form.Label>
  <Form.Control
    type="file"
    name="registration_Form"
    onChange={(e) => handleFileUpload(e, "registration_Form")}
  />
  {formData.registration_Form && (
    <a href={formData.registration_Form} target="_blank" rel="noopener noreferrer">
      {formData.registration_Form.split('/').pop() || "View Registration Form"}
    </a>
  )}
</Form.Group>

{/* Supporting Documents File Upload */}
<Form.Group controlId="formSupportingDocuments" className="mt-3">
  <Form.Label>Supporting Documents</Form.Label>
  <Form.Control
    type="file"
    name="supporting_Documents"
    onChange={(e) => handleFileUpload(e, "supporting_Documents")}
  />
  {formData.supporting_Documents && (
    <a href={formData.supporting_Documents} target="_blank" rel="noopener noreferrer">
      {formData.supporting_Documents.split('/').pop() || "View Supporting Documents"}
    </a>
  )}
</Form.Group>

          </Form>
        </Modal.Body>

        {/* Modal Footer with Action Buttons */}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleFormSubmit}
            disabled={isProcessing}
          >
            {isProcessing ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};


const CompanyDetails = ({ batchId }) => {
  const [companyData, setCompanyData] = useState([]);
  const [openRowIndex, setOpenRowIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default items per page
  const [salesPersons, setSalesPersons] = useState([]); // State to store sales person data
  const [selectedSalesPerson, setSelectedSalesPerson] = useState('');
  const [isSendingEmail, setIsSendingEmail] = useState(false); // Track sending status
  const [sendingStatus, setSendingStatus] = useState({});
  const [sendingCompanyId, setSendingCompanyId] = useState(null);

  const [paymentTypes, setPaymentTypes] = useState({});

  const [isEditable, setIsEditable] = useState(null); // Track the row being edited (null means no row is being edited)
  const [discountFee, setDiscountFee] = React.useState(''); // Tracks the discount fee for the selected row
  const [isConfirmationOpen, setIsConfirmationOpen] = React.useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);

  // Handle payment type change with confirmation
  const handlePaymentTypeChange = (event, contactId) => {
    const selectedPaymentType = event.target.value;

    // Ask for confirmation before changing the payment type
    // const isConfirmed = window.confirm('Are you sure you want to update the payment type?');
    // if (!isConfirmed) return; // If user cancels, return early

    // Update the payment type for the specific contactId
    // setPaymentTypes((prevState) => ({
    //   ...prevState,
    //   [contactId]: selectedPaymentType,
    // }));
    setSelectedPaymentType(selectedPaymentType);
    setSelectedContactId(contactId);
    setPaymentModal(true); // Show confirmation dialog

  };


  useEffect(() => {
    const fetchSalesPersons = async () => {
      try {
        const response = await axios.get('/wsq/sales-person/basic-info');
        setSalesPersons(response.data); // Assuming the response is an array of sales person objects
        const { id } = response.data;
      } catch (error) {
        console.error('Error fetching sales persons:', error);
      }
    };

    fetchSalesPersons();
  }, []);


  const [openEditModal, setOpenEditModal] = useState(false);
  const [contactPerson, setContactPerson] = useState('');

  const [contactNumbers, setContactNumbers] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);



  const handleEditClick1 = (company) => {
    setSelectedCompanyId(company.companyId); // Set the selected company ID
    setContactPerson(company.contactPerson);  // Set the contactPerson value to the current value
    setContactNumbers(company.contactPhoneNumbers || []); // Set the contactNumber value
    setOpenEditModal(true);  // Open the edit modal
  };







  const [salesModel, setSalesModel] = useState(false);

  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedSalesPersonId, setSelectedSalesPersonId] = useState(null);

  const handleSalesPersonChange = async (
    salesPersonId,
    contactId,
    refreshData
  ) => {

    setSalesModel(true);
    setSelectedSalesPersonId(salesPersonId);
    setSelectedContactId(contactId);
  };





  const fetchData = async () => {
    try {
      const response = await axios.get(`wsq/batches/batch/${batchId}/details`);
      setCompanyData(response.data.content);
      setFilteredCompanies(response.data.content);
    } catch (err) {
      setError(err.response?.data?.message || 'Data not avaiable ');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [batchId]);

  const handleActionCompletion = () => {
    fetchData(); // Refetch data after an action in StudentDetailsTable
  };
  const handleRowClick = (index) => {
    setOpenRowIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSearch = () => {
    const filtered = companyData.filter(company =>
      company.uen.toLowerCase() === searchTerm.toLowerCase() // Exact match
    );
    setFilteredCompanies(filtered);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
        <Typography variant="h6" style={{ marginLeft: '20px' }}>
          Loading company details...
        </Typography>
      </Box>
    );
  }

  const handleApprove = (studentId) => {
    console.log(`Approve student with ID: ${studentId}`);
  };

  const handleReject = (studentId) => {
    console.log(`Reject student with ID: ${studentId}`);
  };

  if (error) {
    return (
      <Alert severity="error" style={{ margin: '20px' }}>
        {error}
      </Alert>
    );
  }


  const handleSendEmailStatusUpdate = async (company) => {
    if (sendingCompanyId) {
      return; // Prevent further actions if a company is already being processed
    }

    setSendingCompanyId(company.companyId); // Set the company ID as being processed

    await sendEmailStatusUpdateForAll(company);

    setSendingCompanyId(null); // Reset after email sending is done
  };

  const sendEmailStatusUpdateForAll = async (company) => {
    const studentIds = company.students.map(student => student.id); // Get all student IDs, no status filter

    // Set loading status for all students
    const newSendingStatus = company.students.reduce((acc, student) => {
      acc[student.id] = true;
      return acc;
    }, {});
    setSendingStatus(newSendingStatus);

    try {
      // Check if any student's status is 'new' to decide which API to call
      const apiUrl = company.students.some(student => student.status === 'new')
        ? `/wsq/companies/resend-email-company-new/${company.companyId}` // New API if any student's status is 'new'
        : `/wsq/send-email-status-update/?companyId=${company.companyId}&studentIds=${studentIds.join(',')}`; // Existing API

      const response = await axios.post(apiUrl);

      setSnackbarMessage('Emails sent successfully!');
      setSnackbarOpen(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setSnackbarMessage('Please update status for all students');
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage('Failed to send emails.');
        setSnackbarOpen(true);
      }
      console.error('Error sending email:', error);
    } finally {
      // Reset sending status after email sending is complete
      const resetSendingStatus = company.students.reduce((acc, student) => {
        acc[student.id] = false;
        return acc;
      }, {});
      setSendingStatus(resetSendingStatus);
    }
  };



  const handleEditClick = (contactId) => {
    setIsEditable(contactId); // Set the current row as editable
  };

  const handleCancelClick = () => {
    setIsEditable(null); // Reset to no row being edited
    setDiscountFee(''); // Reset the discount fee
  };

  const handleSaveClick = () => {
    setIsConfirmationOpen(true); // Open confirmation modal
  };

  const handleConfirmSave = async (contactId) => {
    try {
      const response = await axios.put(
        `/api/company-contacts/${contactId}/discount-fee?discountFee=${discountFee}`
      );
      if (response.status === 200) {
        alert('Discount applied successfully!');
        setIsEditable(null); // Reset after saving
        setIsConfirmationOpen(false);
        fetchData()
      } else {
        alert('Failed to apply discount');
      }
    } catch (error) {
      console.error('Error applying discount:', error);
    }
  };

  const handleModalClose = () => {
    setIsConfirmationOpen(false);
  };

  const handleDownload = async (contactId) => {
    const url = `/wsq/approved-by-contact/${contactId}`;
    try {
      const response = await axios.get(`/wsq/approved-by-contact/${contactId}`);
      console.log(response.data);
      handleInvoicePdf(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInvoicePdf = async (data) => {
    const pdfBytes = await fetch(Invoice_company).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const secondPage = pages[1];
    pdfDoc.registerFontkit(fontkit);


    const calibriFontEmbed = pdfDoc.embedStandardFont(StandardFonts.Helvetica);

    const contactNumber = data.contactNumber.join(", ") || "";
    const batchName = data.batchName || "";
    const courseName = data.courseName || "";
    const courseNameAbbrevation = data.courseName || "";
    const discountAmount = data.discountAmount.toFixed(2) || "";

    const feeAmount = data.feeAmount.toFixed(2) || "";


    const date = new Date(data.registerDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();


    const invoiceDate = `${day}/${month}/${year}`;
    const invoiceNumber = data.invoice || "";
    const students = data.students || [];
    const studentsCount = data.students ? data.students.length : "0";
    const language = data.language || "";
    const companyName = data.companyName || "";
    const contactPerson = data.contactPerson || "";

    const totalFee = data.totalFee.toFixed(2) || "";

    const venue = data.venue || "";
    // const batchDays = data?.batchDays || [];
    const sessionDetails = data.sessionDetails || [];
    const salesperson = data.salesPersonName;
    const batchid = data?.batchId || "";
    const paymentMode = data?.paymentMode || "";
    const issuedby = "CD";
    const startDate1 = data?.startDate || "";
    const endDate = data?.endDate || "";

    const fontsize = 10;

    firstPage.drawText(companyName, {
      x: 102,
      y: 680,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(contactPerson, {
      x: 97,
      y: 665,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(contactNumber, {
      x: 125,
      y: 649,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    firstPage.drawText(invoiceNumber, {
      x: 430,
      y: 680,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(invoiceDate, {
      x: 400,
      y: 665,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    firstPage.drawText(issuedby, {
      x: 420,
      y: 629,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    firstPage.drawText(salesperson, { x: 432, y: 647.5, size: fontsize, font: calibriFontEmbed, color: rgb(1, 1, 1) });

    firstPage.drawText(paymentMode, {
      x: 446,
      y: 613,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    //inside table

    firstPage.drawText(`${studentsCount}`, {
      x: 377,
      y: 465,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${feeAmount}`, {
      x: 415,
      y: 465,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${discountAmount}`, {
      x: 474,
      y: 465,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${data.gst}`, {
      x: 522,
      y: 120,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${0}`, {
      x: 522,
      y: 97,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${0}`, {
      x: 522,
      y: 72,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${totalFee}`, {
      x: 522,
      y: 465,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    // Ensure discount calculation is a number
    const dis = (discountAmount * 0.9);

    // Ensure the total calculation is numeric
    // const total = (Number(totalFee) +Number(dis) );
    firstPage.drawText(`$${data.totalPayWithGst}`, {
      x: 522,
      y: 50,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    // firstPage.drawText(batchid, { x: 119, y: 618.5, size: 10, font: calibriFontEmbed, color: rgb(0, 0, 0) });


    secondPage.drawText(startDate1, { x: 72, y: 600, size: fontsize, font: calibriFontEmbed, color: rgb(0, 0, 0) });

    secondPage.drawText(endDate, { x: 172, y: 600, size: fontsize, font: calibriFontEmbed, color: rgb(0, 0, 0) });


    function formatStartDate(startDate1) {
      let date;

      // Check if startDate1 is already a Date object
      if (startDate1 instanceof Date) {
        date = startDate1;
      } else {
        // If it's a string, manually parse it
        const parts = startDate1.split('/');
        const day = parts[0];
        const month = parts[1] - 1; // JavaScript months are 0-indexed
        const year = parts[2];
        date = new Date(year, month, day); // Create Date object
      }

      const formattedDay = String(date.getDate()).padStart(2, "0");
      const formattedMonth = String(date.getMonth() + 1).padStart(2, "0");
      const formattedYear = date.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`; // Return formatted date
    }

    // Utility function to calculate the due date based on payment mode
    function calculateDueDate(startDate1, paymentMode) {
      let date;

      // Check if startDate1 is already a Date object
      if (startDate1 instanceof Date) {
        date = startDate1;
      } else {
        // If it's a string, manually parse it
        const parts = startDate1.split('/');
        const day = parts[0];
        const month = parts[1] - 1; // JavaScript months are 0-indexed
        const year = parts[2];
        date = new Date(year, month, day); // Create Date object
      }

      // Determine due date based on payment mode
      switch (paymentMode) {
        case "7 days":
          date.setDate(date.getDate() + 7);
          break;
        case "15 days":
          date.setDate(date.getDate() + 15);
          break;
        case "30 days":
          date.setDate(date.getDate() + 30);
          break;
        case "COD":
          return formatStartDate(startDate1); // Return the formatted start date
        case "GIRO":
          return "GIRO"; // Return "GIRO" as the value
        default:
          return startDate1; // Return placeholder for invalid modes
      }

      // Format the calculated due date as DD/MM/YYYY
      return formatStartDate(date);
    }

    // Sample usage
    // const startDate1 = "08/12/2024"; // Example input date in DD/MM/YYYY format
    // const paymentMode = "15 days"; // Example payment mode
    const duedate = calculateDueDate(startDate1, paymentMode);

    firstPage.drawText(duedate, { x: 420, y: 595, size: fontsize, font: calibriFontEmbed, color: rgb(1, 1, 1) });

    //sessionDetails time

    let y = 600; // Starting Y-coordinate
    const x = 280; // X-coordinate
    const lineSpacing = 12; // Space between lines
    let dayCounter = 1;

    for (const session of sessionDetails) {
      // Extract the date from the session detail
      const dateMatch = session.match(/\d{2}\/\d{2}\/\d{4}/);
      const sessionDate = dateMatch ? dateMatch[0] : ""; // Keep the date as DD/MM/YYYY

      // Extract the session times
      const timeMatch = session.match(/\((.+)\)/);
      const sessionTime = timeMatch ? timeMatch[1] : "";

      // Split the session times into start and end and format them
      const [startTime, endTime] = sessionTime.split(" - ");
      const formatTime = (time) =>
        time.replace(/\b(\d{1,2}):(\d{2})/, (match, h, m) => {
          const hour = parseInt(h, 10);
          return `${hour % 12 || 12}:${m} ${hour < 12 ? "AM" : "PM"}`;
        });
      const formattedSession = `${formatTime(startTime)} To ${formatTime(endTime)}`;

      // Draw the formatted text
      secondPage.drawText(
        `Day: ${dayCounter} ${sessionDate} ${formattedSession}`,
        {
          x: x,
          y: y,
          size: 10,
          font: calibriFontEmbed,
          color: rgb(0, 0, 0),
        }
      );

      y -= lineSpacing; // Move to the next line
      dayCounter++;
    }





    //students
    // Define the starting position and spacing for student data
    let yStudents = 402; // Starting Y-coordinate for the students list
    const xStudentName = 61; // X-coordinate for the student name
    const xStudentNric = 297; // X-coordinate for the NRIC
    const studentLineSpacing = 12; // Space between each student's line

    let serialNumber = 1;
    // Iterate through the students array and render their details
    for (const student of students) {
      const studentName = student.studentName || "N/A";
      const studentNric = student.nric || "N/A";

      const studentDetails = `${serialNumber}. ${studentName}`;

      // Print the student's name
      firstPage.drawText(studentDetails, {
        x: xStudentName,
        y: yStudents,
        size: fontsize,
        font: calibriFontEmbed,
        color: rgb(0, 0, 0),
      });

      // Print the student's NRIC
      firstPage.drawText(studentNric, {
        x: xStudentNric,
        y: yStudents,
        size: fontsize,
        font: calibriFontEmbed,
        color: rgb(0, 0, 0),
      });

      // Move to the next line
      yStudents -= studentLineSpacing;
      serialNumber++;
    }


    function abbreviateCourseName(courseNameAbbrevation) {
      return courseNameAbbrevation
        .split(' ') // Split the string into words
        .filter(word => word.trim().length > 0) // Filter out empty or whitespace-only words
        .map(word => word[0].toUpperCase()) // Take the first letter of each word and convert it to uppercase
        .join(''); // Join the letters to form the abbreviation
    }

    const getTextWidth = (text, font, fontSize) => {
      const width = font.widthOfTextAtSize(text, fontSize);
      return width;
    };


    function replaceTabs(text) {
      if (typeof text !== 'string') {
        return ''; // Return an empty string if the input is not a valid string
      }
      return text.replace(/\t/g, '    '); // Replace each tab with four spaces
    }

    // Function to draw wrapped text with dynamically adjusted X-axis position
    const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth, textColor = rgb(0, 0, 0)) => {
      text = replaceTabs(text);
      const lines = [];
      let currentLine = '';
      const words = text.split(' ');

      // Split the text into lines based on maxWidth
      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

        if (width < maxWidth) {
          currentLine += (currentLine === '' ? '' : ' ') + word;
        } else {
          lines.push(currentLine.trim());
          currentLine = word;
        }
      }

      if (currentLine !== '') {
        lines.push(currentLine.trim());
      }

      // Draw each line of wrapped text
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        await page.drawText(line, {
          x: x,  // Keep the initial X position for all lines
          y: y - i * fontSize * 1.2,  // Adjust the Y position for each line based on font size
          size: fontSize,
          font,
          color: textColor,
        });
      }

      // Return the total height of the wrapped text (based on the number of lines)
      return lines.length * fontSize;
    };



    const totalHeightUsed = await drawWrappedText(firstPage, courseName, 125, 634, calibriFontEmbed, fontsize, 230, rgb(1, 1, 1));

    await drawWrappedText(secondPage, venue, 100, 667, calibriFontEmbed, 10, 310, rgb(0, 0, 0));

    firstPage.drawText(`Batch ID: ${abbreviateCourseName(courseNameAbbrevation)}-${batchid}`, {
      x: 69,
      y: 647 - totalHeightUsed - 20,
      size: 10,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });


    await drawWrappedText(secondPage, `${(courseName)} - ${language}`, 122, 684, calibriFontEmbed, 10, 500, rgb(0, 0, 0));

    await drawWrappedText(firstPage, `${courseName}`, 62, 470, calibriFontEmbed, fontsize, 298, rgb(0, 0, 0));



    // Save the PDF document
    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-COURSE-RECEIPT.pdf`);
    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
  };



  const handleCloseDialog = () => {
    setSalesModel(false);
    setSelectedSalesPersonId(null);
    setSelectedContactId(null);
  };

  const handleClosePayment = () => {
    setPaymentModal(false); // Close the dialog without saving
    setSelectedContactId(null);
    setSelectedPaymentType(null);

  };

  const handleConfirmsales = async () => {
    const apiUrl = `/wsq/companies/salesPersons/?id=${selectedContactId}&salespersonId=${selectedSalesPersonId}`;

    try {
      const response = await axios.post(apiUrl, { selectedSalesPersonId }); // Include payload if required
      if (response.status === 200) {
        console.log("Salesperson updated successfully.");
        fetchData(); // Refresh the data after successful update
        handleCloseDialog();
      } else {
        console.error("Failed to update salesperson.");
      }
    } catch (error) {
      console.error("Error while updating salesperson:", error);
    }
  };


  const handleConfirmpaymentselect = async () => {
    const apiUrl = `/wsq/companies/PaymentTypeforCompany/?id=${selectedContactId}&paymentType=${selectedPaymentType}`;

    try {
      // Trigger API call when a value is confirmed
      await axios.post(apiUrl);
      fetchData()
      console.log('Payment type updated successfully:', selectedPaymentType);
    } catch (error) {
      console.error('Error updating payment type:', error);
    }
    setPaymentModal(false); // Close the dialog
  };



  return (
    <>
      <Box p={3}>
        <Typography variant="h4" gutterBottom align="center">
          Company Details
        </Typography>

        {/* Search Bar */}
        <Box mb={2} display="flex" justifyContent="center">
          <TextField
            variant="outlined"
            label="Search by UEN"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginRight: '10px' }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setSearchTerm('');
              setFilteredCompanies(companyData);
            }}
            style={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Box>

        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Company Name</TableCell>
                <TableCell>UEN</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Register ID</TableCell>
                <TableCell>Contact Person</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Total Students</TableCell>
                <TableCell>Sales Person</TableCell>
                <TableCell>Payment Type</TableCell>
                <TableCell> Fee</TableCell>
                <TableCell>Special Fee</TableCell>

                <TableCell>Invoice Number</TableCell>
                <TableCell>Invoice Mail</TableCell>
                <TableCell>Invoice Content</TableCell>

                <TableCell>Recipt Mail </TableCell>
                <TableCell>Recipt Download </TableCell>
                <TableCell>Approve Student  </TableCell>
                <TableCell>Reject Student </TableCell>
                <TableCell>Hold Student</TableCell>
                {/* <TableCell>Edit</TableCell> */}


              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCompanies.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="h6">No data present</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredCompanies.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((company, index) => {
                  const approvedCount = company.students.filter(student => student.status === 'approved').length;
                  const rejectedCount = company.students.filter(student => student.status === 'rejected').length;
                  const holdCount = company.students.filter(student => student.status === 'on hold').length;

                  return (
                    <React.Fragment key={company.companyId}>
                      <TableRow
                        // onClick={() => handleRowClick(index)}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: openRowIndex === index ? '#f5f5f5' : 'inherit',
                        }}
                      >
                        <TableCell>
                          <Tooltip title={openRowIndex === index ? 'Collapse' : 'Expand'}>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRowClick(index);
                              }}
                            >
                              {openRowIndex === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{company.clientCompanyName}</TableCell>
                        <TableCell>{company.uen}</TableCell>
                        <TableCell>{company.emailId}</TableCell>
                        <TableCell>{company.registerId}</TableCell>
                        <TableCell>{company.contactPerson}</TableCell>
                        <TableCell>
                          {company.contactPhoneNumbers && company.contactPhoneNumbers.length > 0 ? (
                            <ul style={{ margin: 0, padding: 0, listStyleType: 'none' }}>
                              {company.contactPhoneNumbers.map((phoneNumber, index) => (
                                <li key={index}>{phoneNumber}</li>
                              ))}
                            </ul>
                          ) : (
                            <span>-</span>
                          )}
                        </TableCell>
                        <TableCell>{company.studentCount}</TableCell>

                        <TableCell>
                          <Select
                            sx={{
                              fontSize: '1rem', // Adjust font size
                              minWidth: 200, // Adjust dropdown width
                              height: 40, // Adjust height of dropdown
                            }}
                            value={company.salesPersonId || ""}
                            onChange={(event) => handleSalesPersonChange(event.target.value, company.contactId, fetchData)}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Please select a salesperson</em>
                            </MenuItem>
                            {salesPersons.map((salesPerson) => (
                              <MenuItem key={salesPerson.id} value={salesPerson.id}>
                                {salesPerson.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>



                        <TableCell>
                          <Select
                            value={company.paymentType || ''} // Set the paymentType or empty string if null
                            onChange={(event) => handlePaymentTypeChange(event, company.contactId)}
                            fullWidth
                            sx={{
                              fontSize: '1rem', // Adjust font size
                              minWidth: 200, // Adjust dropdown width
                              height: 40, // Adjust height of dropdown
                            }}
                          >
                            <MenuItem value="" disabled>
                              <em>{company.paymentType ? company.paymentType : 'Select Payment Type'}</em> {/* Display paymentType if available, otherwise show placeholder */}
                            </MenuItem>
                            <MenuItem value="COD">COD</MenuItem>
                            <MenuItem value="7 days">7 days</MenuItem>
                            <MenuItem value="15 days">15 days</MenuItem>
                            <MenuItem value="30 days">30 days</MenuItem>
                            <MenuItem value="GIRO">GIRO</MenuItem>
                          </Select>
                        </TableCell>

                        <TableCell>{company.fee}</TableCell>
                        <TableCell>
                          {isEditable === company.contactId ? ( // Check if this row is editable
                            <div>
                              {/* Input Field */}
                              <TextField
                                label="Discount Fee"
                                type="number"
                                value={discountFee}
                                onChange={(e) =>
                                  setDiscountFee(e.target.value)
                                }
                                fullWidth
                                style={{ marginBottom: "16px" }}
                              />

                              {/* Buttons */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <Tooltip
                                  title={
                                    discountFee > company.fee
                                      ? "Discount amount cannot exceed the actual fee."
                                      : discountFee === ""
                                        ? "Please enter a valid discount amount."
                                        : ""
                                  }
                                  arrow
                                >
                                  <span>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={handleSaveClick}
                                      style={{ marginRight: "8px" }}
                                      disabled={discountFee > company.fee || discountFee === ""} // Disable if invalid
                                    >
                                      Save
                                    </Button>
                                  </span>
                                </Tooltip>


                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  onClick={handleCancelClick}
                                >
                                  Cancel
                                </Button>
                              </div>

                              {/* Confirmation Modal */}
                              <Dialog
                                open={isConfirmationOpen}
                                onClose={handleModalClose}
                              >
                                <DialogTitle>Confirm Save</DialogTitle>
                                <DialogContent>
                                  <DialogContentText>
                                    Are you sure you want to save the discount
                                    fee?
                                  </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    onClick={handleModalClose}
                                    color="secondary"
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    onClick={() =>
                                      handleConfirmSave(company.contactId)
                                    }
                                    color="primary"
                                  >
                                    Confirm
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </div>
                          ) : // Display Add/Edit button based on discountFee status
                            company.discountFee === null ? (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  handleEditClick(company.contactId)
                                }
                              >
                                Add Discount
                              </Button>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{ marginRight: "8px" }}
                                >
                                  {(company.fee - company.discountFee).toFixed(2)}{" "}
                                  {/* Display the discounted value */}
                                </Typography>
                                <IconButton
                                  color="primary"
                                  onClick={() =>
                                    handleEditClick(company.contactId)
                                  }
                                >
                                  <EditIcon />
                                </IconButton>
                              </div>
                            )}
                        </TableCell>
                    <TableCell>
  {company.invoice ? (
    <Link
      component="button"
      onClick={() => {
        if (company.paymentType && company.salesPersonId) {
          handleDownload(company.contactId);
        } else {
          alert("Please select both Payment Type and Salesperson before downloading the invoice.");
        }
      }}
      sx={{
        textDecoration: "none",
        color:
          company.students.some((student) => student.status === "new") ||
          !company.paymentType ||
          !company.salesPersonId
            ? "gray"
            : "blue",
        cursor:
          company.students.some((student) => student.status === "new") ||
          !company.paymentType ||
          !company.salesPersonId
            ? "not-allowed"
            : "pointer",
      }}
    >
      {company.invoice}
    </Link>
  ) : (
    "NA"
  )}
</TableCell>
<TableCell>
  <Button
    variant="contained"
    style={{
      backgroundColor:
        company.students.some((student) => student.status === "new") ||
        !company.paymentType ||
        !company.salesPersonId
          ? "gray"
          : "yellow",
      color:
        company.students.some((student) => student.status === "new") ||
        !company.paymentType ||
        !company.salesPersonId
          ? "lightgray"
          : "black",
    }}
    onClick={() => {
      if (company.paymentType && company.salesPersonId) {
        handleSendEmailStatusUpdate(company);
      } else {
        alert("Please select both Payment Type and Salesperson before sending the email.");
      }
    }}
    disabled={
      sendingCompanyId !== null && sendingCompanyId !== company.companyId
    }
  >
    {company.students.some((student) => sendingStatus[student.id])
      ? "Sending..."
      : "Send Email"}
  </Button>
</TableCell>


                        <TableCell>


                        </TableCell>
                        <TableCell>
                          <Typography variant="body2"></Typography>
                          <Button
                            variant="contained"
                            endIcon={<MailOutlineIcon />} // Using the Mail Icon



                          >
                            Email
                          </Button>
                        </TableCell>


                        <TableCell>
                          <Button variant='Outlined' color='yellow' >
                            <DownloadIcon />
                          </Button>
                        </TableCell>
                        <TableCell>{approvedCount}</TableCell>
                        <TableCell>{rejectedCount}</TableCell>
                        <TableCell>{holdCount}</TableCell>
                        {/* <TableCell>
                          <IconButton onClick={() => handleEditClick1(company)}>
                            <EditIcon />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={15}>
                          <Collapse in={openRowIndex === index} timeout="auto" unmountOnExit>
                            <StudentDetailsTable
                              students={company.students}
                              handleApprove={handleApprove}
                              handleReject={handleReject}
                              onActionComplete={handleActionCompletion}
                            />
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );

                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={filteredCompanies.length} // Total number of items
          page={currentPage - 1} // Current page (0-based index)
          onPageChange={(event, newPage) => setCurrentPage(newPage + 1)} // Page change handler
          rowsPerPage={itemsPerPage} // Number of rows per page
          onRowsPerPageChange={(event) => {
            setItemsPerPage(parseInt(event.target.value, 10)); // Update rows per page
            setCurrentPage(1); // Reset to first page when items per page changes
          }}
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
        />



      </Box>

      <Dialog open={salesModel} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Assignment</DialogTitle>
        <DialogContent>
          Are you sure you want to assign this salesperson to the student?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmsales} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={paymentModal} onClose={handleClosePayment}>
        <DialogTitle>Confirm Payment Type Change</DialogTitle>
        <DialogContent>
          Are you sure you want to assign this salesperson to the student?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePayment} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmpaymentselect} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>




      <ToastContainer />
    </>


  );
};



export default CompanyDetails;
